module.exports = __webpack_public_path__ + "assets/img/icon-bae0285c.png";